import IconSvg from './assets/icons/48/info.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="info" src={IconSvg} width="48px" height="48px" />;

export default Icon;
